import BusinessStatistics from '@/models/loyaltyPanel/BusinessStatistics';
const getDefaultState = () => ({
  storeStatistics: [],
  companyStatistics: {},
  regionStatistics: {},
  activeUsers: null,
  last2MonthsActiveUsers: null,
  companyRegions: [],
  pagination: {},
});

export default {
  namespaced: true,

  state: () => getDefaultState(),

  mutations: {
    resetState(state) {
      Object.assign(state, getDefaultState());
    },
    setStoreStatistics(state, payload) {
      state.storeStatistics = payload;
    },
    setActiveUsers(state, payload) {
      state.activeUsers = payload;
    },
    setLast2MonthsActiveUsers(state, payload) {
      state.last2MonthsActiveUsers = payload;
    },
    setCompanyRegions(state, payload) {
      state.companyRegions = payload;
    },
    setCompanyStatistics(state, payload) {
      state.companyStatistics = payload;
    },
    setRegionStatistics(state, payload) {
      state.regionStatistics = payload;
    },

    setPagination(state, payload) {
      state.pagination = payload;
    },
  },

  actions: {
    async getBusinessStatistics({ commit }, body) {
      try {
        commit('setLoading', true, { root: true });
        let query = '?';
        Object.keys(body.filters).forEach((key) => {
          if (body.filters[key] !== null && body.filters[key] !== '') {
            query += key + '=' + encodeURIComponent(body.filters[key]) + '&';
          }
        });
        query = query.slice(0, -1);

        const { data } = await BusinessStatistics.get(query);
        const payload = data.data || {};
        const storeStatistics = payload.store_statistics || [];
        const companyStatistics = payload.company_statistics || {};
        const regionStatistics = payload.region_statistics || {};
        const pagination = payload.pagination || {};
        commit('setStoreStatistics', storeStatistics);
        commit('setCompanyStatistics', companyStatistics);
        commit('setRegionStatistics', regionStatistics);
        commit('setServerItemsLength', pagination.total || storeStatistics.length, { root: true });
        commit('setPagination', pagination);
        commit('setServerPagination', pagination, { root: true });
        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
      }
    },

    async getActiveUsers({ commit }) {
      try {
        commit('setLoading', true, { root: true });
        const { data } = await BusinessStatistics.getActiveUsers();

        const activeUsers = data.data[0].active_users;

        commit('setActiveUsers', activeUsers);
        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
      }
    },

    async getCompanyRegions({ commit }) {
      try {
        const { data } = await BusinessStatistics.getCompanyRegions();

        const regions = data.data;

        commit('setCompanyRegions', regions);
      } catch (ex) {
        commit('setLoading', false, { root: true });
      }
    },

    async getLast2MonthsActiveUsers({ commit }) {
      try {
        commit('setLoading', true, { root: true });
        const { data } = await BusinessStatistics.getLast2MonthsActiveUsers();

        const last2MonthsActiveUsers = data.data[0].active_users;

        commit('setLast2MonthsActiveUsers', last2MonthsActiveUsers);
        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
      }
    },
  },
};
